import { useEffect, useState } from 'react'
import { config as siteConfig } from '@crunchyroll/cr-static-shared-components'
import { datadogRum } from '@datadog/browser-rum'

import { hasPerformanceConsent, CONSENT_EVENTS } from '@utils'
import config from '@data/config'

const DatadogWrapper = ({ children }) => {
  const [datadogAllowed, setDatadogAllowed] = useState(false)

  const { env } = siteConfig

  useEffect(() => {
    if (typeof window === 'undefined') return false

    setDatadogAllowed(hasPerformanceConsent())

    const onChange = () => setDatadogAllowed(hasPerformanceConsent())

    CONSENT_EVENTS.forEach((evt) => window.addEventListener?.(evt, onChange))
    return () => {
      CONSENT_EVENTS.forEach((evt) =>
        window.removeEventListener?.(evt, onChange)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let isDatadogRumInitialized = false

    if (datadogAllowed && !isDatadogRumInitialized) {
      datadogRum.init({
        ...config.datadog,
        env,
        defaultPrivacyLevel: 'mask-user-input',
        setTrackingConsent: 'granted',
      })
      datadogRum.startSessionReplayRecording()
      isDatadogRumInitialized = true
    }

    if (isDatadogRumInitialized) {
      if (datadogAllowed) {
        datadogRum.setTrackingConsent('granted')
      } else {
        datadogRum.setTrackingConsent('not-granted')
      }
    }
  }, [datadogAllowed])

  return children
}

export default DatadogWrapper
